import React from 'react';
import { motion } from 'framer-motion';
import styles from './FAB.module.css';

interface FABProps {
  onClick: () => void;
  icon?: React.ReactNode;
  label?: string;
}

export function FAB({ onClick, icon = '+', label = 'Add new block' }: FABProps) {
  return (
    <motion.button
      className={styles.fab}
      onClick={onClick}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      aria-label={label}
    >
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
    </motion.button>
  );
}

export default FAB;
